export default __webpack_public_path__ + "static/media/dante-elektro-logo.6a6749e4.png";